import { useTheme } from "../../contexts/ThemeContext";

export default function ThemeToggle({ collapsed = false }) {
  const { isDark, toggle } = useTheme();
  return (
    <button
      onClick={toggle}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: collapsed ? "center" : "flex-start",
        gap: collapsed ? 0 : 10,
        padding: collapsed ? "10px" : "9px 14px",
        borderRadius: 10,
        border: "none",
        cursor: "pointer",
        width: "100%",
        background: isDark ? "rgba(96,165,250,0.08)" : "rgba(212,146,42,0.08)",
        transition: "all 0.25s ease",
        fontFamily: "'DM Sans', sans-serif",
      }}
    >
      <div
        style={{
          width: 38,
          height: 20,
          borderRadius: 12,
          position: "relative",
          background: isDark ? "#1E3348" : "#E2E7ED",
          transition: "background 0.25s ease",
          flexShrink: 0,
        }}
      >
        <div
          style={{
            width: 16,
            height: 16,
            borderRadius: 10,
            position: "absolute",
            top: 2,
            left: isDark ? 2 : 20,
            background: isDark ? "#60A5FA" : "#E8A838",
            transition: "left 0.25s ease, background 0.25s ease",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 9,
          }}
        >
          {isDark ? "🌙" : "☀️"}
        </div>
      </div>
      {!collapsed && (
        <span
          style={{
            fontSize: 12,
            fontWeight: 500,
            color: isDark ? "#60A5FA" : "#D4922A",
          }}
        >
          {isDark ? "Escuro" : "Claro"}
        </span>
      )}
    </button>
  );
}
